<!-- results-table.component.html -->
<h1 mat-dialog-title></h1>
<div mat-dialog-content fxLayout="column">

<div fxLayout="column" fxFlex="100" >

  <div fxLayout="column" fxFlex="100" class="print">

      <div fxLayout="row" class="p-20">

        <div fxFlex fxLayout="row">
            <div fxFlex="50"><strong>{{organizacion}}</strong></div>
            <div fxFlex="50" fxLayout="column">
                            <div fxFlex fxLayoutAlign="end start">
                <img class="logo-icon" src="assets/images/logos/logo_RIC_horizontal_transparente.png" height="67" width="200" >
              </div>
              <div fxFlex fxLayoutAlign="end start" style="margin-right:20px">
                {{fecha | date:'dd/MM/yyyy'}}
              </div>
          </div>
        </div>
      </div>

      <div>
        <h1 class="p-20"><strong>Evaluación Consolidada</strong></h1>
      </div>
  
      <div fxLayout="column" class="p-20">

        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Nombre: </strong>{{LOCAL_DATA.nombre}}</div>
            <div fxFlex="30"><strong>Dueño: </strong>{{LOCAL_DATA.responsable.nombreCompleto}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Tipo de Evaluación: </strong>{{LOCAL_DATA.tipo.nombre}}</div>
            <div fxFlex="30"><strong>Creado por: </strong>{{LOCAL_DATA.creador.nombreCompleto}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Estructura jerarquíca/Nodo: </strong>{{LOCAL_DATA.estructuraJerarquica.nombre}} / {{LOCAL_DATA.nodoEstructuraJerarquica.nombre}}</div>
            <div fxFlex="30"><strong>Fecha inicio: </strong>{{LOCAL_DATA?.fechaInicio | date:'dd/MM/yyyy'}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Escenario: </strong>{{LOCAL_DATA.escenario.nombre}}</div>
            <div fxFlex="30"><strong>Fecha fin: </strong>{{LOCAL_DATA?.fechaFin | date:'dd/MM/yyyy'}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
          <div fxFlex="70"><strong>Tipo de Ponderación: </strong>{{LOCAL_DATA.tipo}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Factor de Ponderación: </strong>{{LOCAL_DATA.factorPonderacion.nombre}}</div>
        </div>
      </div>
  
  </div>

  <div class="content p-24" fxFlex="100" fxLayout="row">

      <div fxFlex class="content p-20" fxLayout="column">

        <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" >

        <!-- WIDGET GROUP -->
          <div class="widget-group" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

               <table mat-table [dataSource]="riesgos" #mytable class="my-table mat-elevation-z8">

                 <ng-container matColumnDef="evaluacion">
                   <th mat-header-cell *matHeaderCellDef> Evaluación </th>
                   <td mat-cell *matCellDef="let element"> {{element.evaluacion?.nombre}} </td>
                 </ng-container>


                 <ng-container matColumnDef="objetivo">
                   <th mat-header-cell *matHeaderCellDef> Objetivo </th>
                   <td mat-cell *matCellDef="let element"> {{element.objetivo?.nombre}} </td>
                 </ng-container>

                 <ng-container matColumnDef="riesgo">
                   <th mat-header-cell *matHeaderCellDef> Riesgo </th>
                   <td mat-cell *matCellDef="let element"> {{element.riesgo?.nombre}} </td>
                 </ng-container>

                 <!--
                 <ng-container matColumnDef="control">
                   <th mat-header-cell *matHeaderCellDef mat-sort-header> Control instalado </th>
                   <td mat-cell *matCellDef="let element"> {{element.topAnalisisResidual?.control}}</td>
                 </ng-container>-->

                 <ng-container matColumnDef="probabilidad">
                   <th mat-header-cell *matHeaderCellDef mat-sort-header> Probabilidad Residual</th>
                   <td mat-cell *matCellDef="let element">
                     <span matTooltip="{{element.topAnalisisResidual?.probabilidad?.nombre}}"
                     matTooltipPosition="right">{{element.topAnalisisResidual?.probabilidad?.valor | number:'1.2-2'}}
                      </span>
                    </td>
                 </ng-container>

                 <ng-container matColumnDef="impacto">
                   <th mat-header-cell *matHeaderCellDef mat-sort-header> Impacto Residual</th>
                   <td mat-cell *matCellDef="let element">
                     <span matTooltip="{{element.topAnalisisResidual?.impacto?.nombre}}"
                     matTooltipPosition="right">{{element.topAnalisisResidual?.impacto?.valor | number:'1.2-2'}}
                      </span>
                    </td>
                 </ng-container>

                 <ng-container matColumnDef="factor">
                   <th mat-header-cell *matHeaderCellDef mat-sort-header>Factor Ponderación</th>
                   <td mat-cell *matCellDef="let element"> {{element.factor?.factor | number:'1.2-2'}} </td>
                 </ng-container>

                 <ng-container matColumnDef="impactoPonderado">
                   <th mat-header-cell *matHeaderCellDef mat-sort-header>Impacto Ponderado</th>
                   <td mat-cell *matCellDef="let element"> {{element.impactoPonderado | number:'1.2-2'}} </td>
                 </ng-container>


                 <ng-container matColumnDef="exposicion">
                   <th mat-header-cell *matHeaderCellDef mat-sort-header>Exposición Residual</th>
                   <td mat-cell *matCellDef="let element"> {{element.topAnalisisResidual?.exposicion | number:'1.2-2'}} </td>
                 </ng-container>


                 <ng-container matColumnDef="clasificacion">
                   <th mat-header-cell *matHeaderCellDef mat-sort-header>Clasificación</th>
                   <td mat-cell *matCellDef="let element">
                     <div [ngClass]="{'success' : element.topAnalisisResidual?.clasificacion=='Aceptable',  'error' : element.topAnalisisResidual?.clasificacion=='Inaceptable', 'warning' : element.topAnalisisResidual?.clasificacion=='Atención'}">{{element.topAnalisisResidual?.clasificacion}}</div> </td>
                 </ng-container>

                 <tr mat-header-row *matHeaderRowDef="displayedColumnsAnalisisResidual" class="print"></tr>
                 <tr mat-row *matRowDef="let row; columns: displayedColumnsAnalisisResidual;" class="print"></tr>
               </table>
          </div>


          </div>
      </div>

  </div>

  <div fxLayout="column" fxFlex="100" class="print">

      <div fxLayout="row" class="p-20">

        <div fxFlex fxLayout="column">
            <div fxFlex="100"><strong>Escenario: </strong>{{escenario.nombre}}</div>
        </div>
      </div>


  <div class="content p-24" fxFlex="100" fxLayout="row">

        <div class="content p-5" fxLayout="column" fxFlex="50">
          <div><strong>Heurísticos guía para estimar la Probabilidad</strong></div>
          <div fxFlex class="content p-20">
              <table mat-table [dataSource]="dataSourceE" #tableProbabilidad class="my-table mat-elevation-z8 select-list" fxFlex>


                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef> Nombre </th>
                  <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                </ng-container>

                <ng-container matColumnDef="valor">
                  <th mat-header-cell *matHeaderCellDef> Valor </th>
                  <td mat-cell *matCellDef="let element"> {{element.valor | number:'1.2-2'}} </td>
                </ng-container>

                <ng-container matColumnDef="descripcion">
                  <th mat-header-cell *matHeaderCellDef> Descripcion </th>
                  <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsEscenario"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsEscenario;"></tr>
              </table>
            </div>

            <div fxLayout="row">

              <div fxFlex fxLayout="column">
                  <div fxFlex="100"><strong>Fórmula para el cálculo de Exposición: </strong>{{escenario.formulaDeExposicion}}</div>
              </div>
            </div>
        </div>


        <div class="content p-5" fxLayout="column" fxFlex="50">
          <div><strong>Heurísticos guía para estimar el Impacto</strong></div>
          <div fxFlex class="content p-20">
            <table mat-table [dataSource]="dataSourceI" #tableImpacto class="my-table mat-elevation-z8 select-list" fxFlex>


              <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef> Nombre </th>
                <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
              </ng-container>

              <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef> Valor </th>
                <td mat-cell *matCellDef="let element"> {{element.valor | number:'1.2-2'}} </td>
              </ng-container>

              <ng-container matColumnDef="descripcion">
                <th mat-header-cell *matHeaderCellDef> Descripcion </th>
                <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsEscenario"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsEscenario;"></tr>
            </table>
          </div>

          <div fxLayout="row">

            <div fxFlex fxLayout="column">
                <div fxFlex="100"><strong>Apetito al Riesgo: </strong>{{escenario.apetito}}</div>
                <div fxFlex="100"><strong>Tolerancia al Riesgo: </strong>{{escenario.tolerancia}}</div>
            </div>
          </div>

        </div>


  </div>


  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="printPdf()">{{'Imprimir' | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
